import React, { useEffect, useState } from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Technology from '../components/Technology';
import About from '../components/About';
import Team from '../components/Team';
import Contact from '../components/Contact';
import Reviews from '../components/Reviews';
import FAQ from '../components/FAQ';
import RecentArticles from '../components/RecentArticles';
import SEO from '../components/SEO';
import { api } from '../lib/api';

const HOMEPAGE_FAQS = [
  {
    q: 'Where is Akira Signature Care located?',
    a: "Akira Signature Care is located at 506 North Garfield Avenue, Suite 210, Alhambra, CA 91801 — in the heart of the San Gabriel Valley, minutes from Pasadena, San Marino, San Gabriel and Monterey Park.",
  },
  {
    q: 'What services do you offer?',
    a: "We offer FDA-cleared aesthetic treatments (XERF radiofrequency skin tightening, Thulium and CO2 laser, IPL photofacial, microneedling, RF microneedling, microdermabrasion), injectables (Botox, Dysport, Letybo, Xeomin, Restylane, Juvéderm, Sculptra, Radiesse), regenerative therapies (PRP and PRF), HydraFacial with red light therapy, plus precision health programmes including GLP-1 weight management, hormone optimization, longevity medicine, functional medicine, and VISIA skin analysis.",
  },
  {
    q: 'Are treatments at Akira physician-led?',
    a: "Yes. Every treatment plan is directed by a physician — not delegated — and all injectables are administered by our board-certified medical team.",
  },
  {
    q: 'Do you offer GLP-1 weight loss treatments?',
    a: "Yes. We offer FDA-approved GLP-1 medications for chronic weight management, paired with metabolic and body-composition testing. The average patient experiences 10–15% body-weight loss with ongoing physician oversight.",
  },
  {
    q: 'How do I book a consultation?',
    a: "You can book directly online via our booking link, send a message via our contact page, or call (626) 737-3183.",
  },
  {
    q: 'What makes Akira different from a typical medical spa?',
    a: "We combine medical aesthetics with precision health — biological-age testing, advanced biomarkers, hormone optimization, and longevity-focused care — in a boutique, physician-led setting that treats every patient as an individual.",
  },
];

const HomePage = () => {
  const [recentPosts, setRecentPosts] = useState(null);

  useEffect(() => {
    api('/api/blog')
      .then((data) => setRecentPosts(Array.isArray(data) ? data.slice(0, 3) : []))
      .catch(() => setRecentPosts([]));
  }, []);

  // Most recent post date drives the homepage's dateModified — gives Google
  // and AI bots an explicit freshness signal that updates whenever we publish.
  const latestPostDate =
    recentPosts && recentPosts.length > 0 && recentPosts[0].created_at
      ? new Date(recentPosts[0].created_at).toISOString()
      : null;

  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: HOMEPAGE_FAQS.map(({ q, a }) => ({
        '@type': 'Question',
        name: q,
        acceptedAnswer: { '@type': 'Answer', text: a },
      })),
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': 'https://akirasignaturecare.com/#webpage',
      url: 'https://akirasignaturecare.com/',
      name: 'Akira Signature Care — Medical Spa in Alhambra, CA',
      isPartOf: { '@id': 'https://akirasignaturecare.com/#website' },
      about: { '@id': 'https://akirasignaturecare.com/#clinic' },
      inLanguage: 'en-US',
      ...(latestPostDate ? { dateModified: latestPostDate } : {}),
    },
  ];

  return (
    <>
      <SEO
        title="Medical Spa in Alhambra"
        description="Physician-led medical spa in Alhambra, CA — Botox, fillers, microneedling, XERF & PRP with Angela Trias, M.D. 5★ Google. Book (626) 737-3183."
        path="/"
        schema={schema}
      />
      <Hero />
      <div id="services">
        <Services />
      </div>
      <div id="technology">
        <Technology />
      </div>
      <div id="about">
        <About />
        <Team />
      </div>
      <Reviews />
      <FAQ
        items={HOMEPAGE_FAQS}
        title="Common Questions, Answered"
        subtitle="Everything you need to know about getting started at Akira Signature Care."
      />
      <RecentArticles posts={recentPosts} />
      <div id="contact">
        <Contact />
      </div>
    </>
  );
};

export default HomePage;
